import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES } from '../../lib/i18n';
import { cn } from '../../lib/cn';

export function LanguageSwitcher({ className }: { className?: string }): JSX.Element {
  const { i18n } = useTranslation();
  const active = i18n.resolvedLanguage ?? i18n.language;

  return (
    <div className={cn('flex items-center gap-1', className)} role="group" aria-label="Language">
      {SUPPORTED_LANGUAGES.map((lang) => {
        const isActive = active === lang.code;
        return (
          <button
            key={lang.code}
            type="button"
            aria-label={lang.label}
            aria-pressed={isActive}
            title={lang.label}
            onClick={() => {
              if (i18n.language !== lang.code) void i18n.changeLanguage(lang.code);
            }}
            className={cn(
              'flex h-8 w-8 items-center justify-center rounded-md text-xl leading-none transition-all',
              'hover:bg-surface-100',
              isActive
                ? 'opacity-100 ring-2 ring-brand-600 ring-offset-1 ring-offset-white'
                : 'opacity-60 hover:opacity-100',
            )}
          >
            <span aria-hidden>{lang.flag}</span>
          </button>
        );
      })}
    </div>
  );
}
